import React from "react";

export default class ExchangeList extends React.Component {
	handleExchangeSelect(exchange, e) {
		this.props.onExchangeSelect(exchange);
	}
	render() {
		if (!this.props.showDropDown) return null;
		return (
			<ul className="dropdown-menu" role="menu">
				<li><a href="#" onClick={this.handleExchangeSelect.bind(this, "ALL")}>ALL</a></li>
				<li><a href="#" onClick={this.handleExchangeSelect.bind(this, "NSE")}>NSE</a></li>
				<li><a href="#" onClick={this.handleExchangeSelect.bind(this, "BSE")}>BSE</a></li>
			</ul>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/ExchangeList.jsx
 **/